import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PanitiaLogin: React.FC = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { loginPanitia } = useAuth();

  // Validasi input
  const validateInput = (data: { username: string; password: string }) => {
    if (!data.username.trim() || !data.password.trim()) {
      return 'Username dan password harus diisi';
    }
    
    if (data.username.length > 50) {
      return 'Username terlalu panjang (maksimal 50 karakter)';
    }
    
    if (data.password.length > 255) {
      return 'Password terlalu panjang';
    }
    
    // Sanitasi input - hapus karakter berbahaya
    const sanitizedUsername = data.username.replace(/[<>"'&]/g, '');
    if (sanitizedUsername !== data.username) {
      return 'Username mengandung karakter yang tidak diizinkan';
    }
    
    return null;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Validasi input
      const validationError = validateInput(formData);
      if (validationError) {
        setError(validationError);
        setLoading(false);
      return;
    }

      const response = await fetch('https://event.petirs.id/backend/api/panitia-login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: formData.username.trim(),
          password: formData.password
        }),
      });

      const data = await response.json();

      if (data.success) {
        console.log('Login successful, calling loginPanitia...');
        const loginResult = await loginPanitia(formData.username, formData.password);
        console.log('loginPanitia result:', loginResult);
        if (loginResult) {
          console.log('Navigating to panitia-dashboard...');
          navigate('/panitia-dashboard');
        } else {
          setError('Gagal menyimpan data login');
        }
      } else {
        setError(data.message || 'Login gagal');
      }
    } catch (err) {
      setError('Terjadi kesalahan koneksi. Silakan coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    
    // Batasi panjang input
    if (name === 'username' && value.length > 50) return;
    if (name === 'password' && value.length > 255) return;
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Login Panitia
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Masuk sebagai panitia event
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="username" className="sr-only">
                Username
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Username"
                value={formData.username}
                onChange={handleInputChange}
                maxLength={50}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
                maxLength={255}
              />
            </div>
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800">
              {error}
                  </h3>
                </div>
              </div>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Memproses...' : 'Login'}
            </button>
          </div>

          <div className="text-center">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="text-sm text-blue-600 hover:text-blue-500"
            >
              Kembali ke Login Peserta
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PanitiaLogin; 